import { Component, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debug } from 'console';
import { Key } from 'protractor';
import { CustomerOrderStatus } from 'src/app/Enums/order';
import { AdminOrderListVM, AllOrderList, OrderStatusVM } from 'src/app/models/customer/customer.model';
import { ProductResponseModel } from 'src/app/models/Home/home-list.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { AdminOrderListService } from 'src/app/services/admin-order-list.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-admin-order-list',
  templateUrl: './admin-order-list.component.html',
  styleUrls: ['./admin-order-list.component.css']
})


export class AdminOrderListComponent implements OnInit {

  adminOrderList: AdminOrderListVM = new AdminOrderListVM();
  adminAllOrderList: AllOrderList = new AllOrderList();
  productImageResponseModel: ProductResponseModel = new ProductResponseModel();
  CustomerOrderStatus: typeof CustomerOrderStatus = CustomerOrderStatus;
  orderStatusVM: OrderStatusVM = new OrderStatusVM();
  pagingModel: PagingModel;
  Loader: boolean = false;
  totalPages: number;
  pageNumber: number = 1;
  productId: number;
  startDate: string;
  endDate: string;
  showStartDateError: boolean = false;
  showEndDateError: boolean = false;
  selectedFilter: string;
  imageLoader: boolean = false;
  selectedActiveValue: boolean;
  LoaderOrder: boolean = false;
  orderStatus : string = "";
  customerOrderStatusArray:Array<string>;  
  selectedValue : string = "";
  statusRest: boolean = true;
  OrderStatus: string = "5";
  maxDate: any = new Date();
  searchValue: string = "";
  ProductId: number;
  
  constructor(private homePageService: HomePageService, private alertify: AlertifyService, private _adminOrderListService: AdminOrderListService, private router: Router, private route: ActivatedRoute, private getProductService: ProductService) {

    this.pagingModel = new PagingModel();
    this.pagingModel.pageNumber = 1;    
    var customerStatusValues = new Array<string>();  
    Object.values(CustomerOrderStatus).map(function(key){       
      if (typeof(key) == 'string') {
        customerStatusValues.push(key);
      }  
    });
    this.customerOrderStatusArray = customerStatusValues;
   
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {        
    this.adminOrderListing();
  }

  onDateChange() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
  }

  onEndDateChange() {
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
  }
  onChangeFilter(value) {
    this.selectedFilter = value;
  }

  resetFilter() {
    this.searchValue = "";
    this.startDate = "";
    this.endDate = "";
    this.OrderStatus = "5";
    this.adminOrderList.OrderStatus = "5";
    this.adminOrderList.PageNumber = 1;
    this.adminOrderList.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.selectActive("");
    this.adminOrderListing();
  }


  filter() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
    this.adminOrderList.PageNumber = 1;
    this.adminOrderList.PageSize = 10;
    this.adminOrderList.Keyword = this.searchValue;
    this.adminOrderList.StartDate = this.startDate;
    this.adminOrderList.EndDate = this.endDate;
    this.adminOrderList.ProductId = this.productId;
    this.adminOrderListing();
  }

  adminOrderListing() {
    this.adminOrderList.StartDate = this.startDate;
    this.adminOrderList.EndDate = this.endDate;
    this.adminOrderList.Keyword = this.searchValue;
    this.Loader = true;
    this._adminOrderListService.showAdminAllOrderlisting(this.adminOrderList)
      .subscribe(response => {
        this.Loader = false;
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.adminAllOrderList.CustomerOrdeList = responseBody.responseData;
          this.adminAllOrderList.CustomerOrdeList.forEach((element, index) => {
            this.adminAllOrderList.CustomerOrdeList[index].imageLoader = true;
            this.ProductId = element.productId;
            this.homePageService.ProductImageList(this.ProductId)
              .subscribe((response) => {
                let responseimage = JSON.parse(response._body)
                if (responseimage.isSuccess) {
                  this.adminAllOrderList.CustomerOrdeList[index].productImage = responseimage.responseData;
                  this.adminAllOrderList.CustomerOrdeList[index].imageLoader = false;
                } (err) => {
                }
              })
          });
          this.adminAllOrderList.TotalPages = responseBody.totalPages;
          this.totalPages = this.adminAllOrderList.TotalPages == undefined ? 0 : this.adminAllOrderList.TotalPages;
        } else {
          this.alertify.error(responseBody.responseMessage);
          this.Loader = false;
        }
      });
  }

  loadPage(pagingModel: PagingModel) {
    this.adminOrderList.PageNumber = pagingModel.pageNumber;
    this.adminOrderList.PageSize = pagingModel.pageSize;
    this.adminOrderListing();
  }

  singleOrderDetail(item) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/admin-single-order-list/' + item.id]));
      window.open('#' + url, '_blank');
  }

  selectActive(selectedValue) {
    this.adminOrderList.OrderStatus = selectedValue;
  }

  productImage(item){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + item.productId]));
      window.open('#' + url, '_blank');
  }
}
